_ = require('lodash')
moment = require('moment')
$ = require('jquery')

GroupListMembersPmCtrl = ($scope ,$translate ,$filter ,flash ,$location ,$route ,GroupMemberService ,$ngConfirm ) ->
  pageSize = 4
  listMemberCtrl = this
  listMemberCtrl.listMember = []
  listMemberCtrl.listMemberChanged = []
  listMemberCtrl.currentPage = 0
  listMemberCtrl.isLoading = false
  listMemberCtrl.isSubmitting = false
  listMemberCtrl.noResults = true
  listMemberCtrl.totalPages = 0
  listMemberCtrl.keyword = ""

  listMemberCtrl.loadMore = ->
    listMemberCtrl.isLoading = true
    listMemberCtrl.currentPage++
    params =
      id : $scope.groupDetail.id
      page_size : pageSize
      page : listMemberCtrl.currentPage
      keyword: listMemberCtrl.keyword
    GroupMemberService.listMembers(params)
    .then (data) ->
      listMemberCtrl.listMember = _.union(listMemberCtrl.listMember , data.members )
      listMemberCtrl.totalPages = data.total_pages
      listMemberCtrl.noResults = listMemberCtrl.listMember.length == 0
    .finally ->
      listMemberCtrl.isLoading = false

  listMemberCtrl.hasChanged = ->
    listMemberCtrl.listMemberChanged.length > 0

  listMemberCtrl.hasMore = ->
    listMemberCtrl.noResults == false && listMemberCtrl.currentPage < listMemberCtrl.totalPages

  listMemberCtrl.changeMembers = ->
    if listMemberCtrl.listMemberChanged.length < 1
      return
    listMemberCtrl.isSubmitting = true
    params =
      id : $scope.groupDetail.id
      group_entries : listMemberCtrl.listMemberChanged.map((item) ->
        data =
          group_entry_id : item.group_entry_id
          role : item.newPermission
        data
      )
    GroupMemberService.changeMembers(params).then (resp) ->
      listMemberCtrl.keyword = ""
      $route.reload()
    .catch (resp) ->
      if resp.data?.code is 'error.group_not_admin_error'
        $ngConfirm(($filter('translate')('_GROUP.TOOLBAR.NOT_ALLOWED_LEAVE_GROUP')))
      else
        flash.error $filter('translate')('API_ERROR')
    .finally ->
      listMemberCtrl.isSubmitting = false

  listMemberCtrl.searchMember = ->
    refeshPage()

  $scope.$watch('listMemberCtrl.listMember' , ->
    checkChangedPermission()
  , true)

  refeshPage = ->
    listMemberCtrl.listMember = []
    listMemberCtrl.currentPage = 0
    listMemberCtrl.isLoading = false
    listMemberCtrl.noResults = true
    listMemberCtrl.totalPages = 0
    listMemberCtrl.loadMore()

  checkChangedPermission = ->
    listMemberCtrl.listMemberChanged = $filter('filter')(listMemberCtrl.listMember , (item) ->
      item.newPermission && item.newPermission != ''
    )

  listMemberCtrl.loadMore()
  listMemberCtrl

GroupListMembersPmCtrl.$inject = [
  '$scope'
  '$translate'
  '$filter'
  'flash'
  '$location'
  '$route'
  'GroupMemberService'
  '$ngConfirm'
]

module.exports = GroupListMembersPmCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-member/group-list-member-permission-controller.coffee